var _circle, _path, _rect, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 266,
    viewBox: "0 0 266 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 133,
    cy: 133,
    r: 133,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M167.791 44H128.845V183.556C128.845 205.065 146.282 222.502 167.791 222.502H197V183.556L167.791 183.556H187.244C176.534 183.546 167.848 174.889 167.791 164.19V134.419H197V95.4733H167.791V44Z",
    fill: "#369FFF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    y: 95.4733,
    width: 38.9458,
    height: 127.028,
    fill: "#369FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.242 49.7035L87.4729 44L73.7035 49.7035L68 63.4729L73.7035 77.2423L87.4729 82.9458L101.242 77.2423L106.946 63.4729L101.242 49.7035ZM82.0612 55.748C81.7391 55.5453 81.332 55.8304 81.4124 56.2023L84.7137 71.4765C84.792 71.8385 85.261 71.9385 85.48 71.6399L89.0536 66.768C89.1091 66.6924 89.1877 66.637 89.2775 66.6103L95.1844 64.8533C95.5383 64.748 95.6033 64.2747 95.2908 64.078L82.0612 55.748Z",
    fill: "#12DC9F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.1d0e081383f81ac7b572653e6917f051.svg";
export { ForwardRef as ReactComponent };